import React from 'react';
import { HashRouter, Route } from 'react-router-dom';
import LoginPage from 'src/pages/LoginPage/LoginPage';

const AuthRoutes: React.FC = () => {
    return(
        <HashRouter>
            <Route  path='/' exact component={LoginPage} />
        </HashRouter>
    );
}

export default AuthRoutes;